/* AtomOffice sort & filter add-on (snippets/ao-facets.liquid). Runs beside the stock facets.js,
   which re-renders every .js-filter's innerHTML after a change, so all handlers here are delegated
   and all open/closed state lives on the .js-filter element itself (details[open] on desktop,
   .is-open on the phone sheet's groups). */
(function () {
  var root = document.querySelector('.ao-facets');
  if (!root) return;

  function closePills(except) {
    root.querySelectorAll('details.ao-f__group[open]').forEach(function (d) { if (d !== except) d.removeAttribute('open'); });
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('summary.ao-f__pill');
    if (pill && root.contains(pill)) { closePills(pill.parentElement); return; }   /* native toggle opens this one */
    if (!e.target.closest('details.ao-f__group')) closePills();

    var head = e.target.closest('[data-ao-acc]');
    if (head && root.contains(head)) {
      var group = head.closest('.ao-f__mgroup');
      var open = group.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    var more = e.target.closest('[data-ao-more]');
    if (more && root.contains(more)) {
      var all = more.closest('.ao-f__pills').classList.toggle('is-all');
      more.setAttribute('aria-expanded', all ? 'true' : 'false');
    }
    /* A group's own Reset link: facets.js does not rebuild the group the click came from, so clear
       its ticks / prices here or they stay set while the filter is gone. */
    var reset = e.target.closest('.js-filter facet-remove a');
    if (reset && root.contains(reset)) {
      var g = reset.closest('.js-filter');
      g.querySelectorAll('input[type="checkbox"]').forEach(function (c) { c.checked = false; });
      var pbox = g.querySelector('[data-ao-price]');
      if (pbox) { fields(pbox).forEach(function (f) { f.value = ''; }); pbox._aoApplied = key(pbox); paint(pbox, true); }
    }
    var close = e.target.closest('[data-ao-close]');
    if (close && root.contains(close)) {
      var summary = close.closest('facet-drawer') && close.closest('facet-drawer').querySelector('summary');
      if (summary) summary.click();   /* the theme's drawer controller owns open/close */
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePills(); });
  document.addEventListener('change', function (e) {
    if (e.target.matches('.ao-f__sort input[name="sort_by"]')) closePills();
  });

  /* "Find brand…" box inside a pill: filters the options on screen only. Stopped in the capture
     phase so facets.js's form-level input listener doesn't submit a filter request per keystroke. */
  document.addEventListener('input', function (e) {
    var box = e.target;
    if (!box.matches || !box.matches('[data-ao-find]')) return;
    e.stopPropagation();
    var q = box.value.trim().toLowerCase();
    box.closest('.ao-f__pop').querySelectorAll('.ao-f__opt').forEach(function (li) {
      li.hidden = !!q && (li.getAttribute('data-name') || '').indexOf(q) < 0;
    });
  }, true);

  /* ---------- price ----------
     [data-ao-price] wraps a readout ([data-ao-prange]), the stock <price-range> slider (desktop only)
     and two number fields, from then to. Three things the stock code gets wrong are handled here:
     - a typed price never moved the slider, and was sent to the server on every 500 ms pause in
       typing (so "1500" could be applied as "1"). Typing now only repaints; the price is applied
       when the shopper stops typing for a moment, presses Enter or leaves the field.
     - after one slider drag, every later mouseup anywhere on the page re-submitted the filters.
     - a drag was submitted from the <form> itself, so facets.js rebuilt the group being edited
       under the mouse. It is now re-sent from a field inside the group, which facets.js leaves alone
       apart from its .facets__selected label. */
  var IDLE_MS = 700;
  function fields(box) { return box.querySelectorAll('input[type="number"]'); }
  function money(box, n) {
    var txt = (Math.round(n * 100) / 100).toLocaleString('en-US', { maximumFractionDigits: 2 });
    return (box.getAttribute('data-money') || '0').replace(/0(?![\s\S]*0)/, txt);
  }
  function range(box) {
    var f = fields(box), max = Number(box.getAttribute('data-max')) || 0;
    var clamp = function (v) { return Math.max(0, Math.min(v, max)); };
    var a = f[0].value === '' ? 0 : clamp(Number(f[0].value) || 0);
    var b = f[1].value === '' ? max : clamp(Number(f[1].value) || 0);
    return { lo: Math.min(a, b), hi: Math.max(a, b), max: max };
  }
  function key(box) { var f = fields(box); return f[0].value + '|' + f[1].value; }
  function paint(box, moveThumbs) {
    var r = range(box);
    var out = box.querySelector('[data-ao-prange]');
    if (out) out.textContent = money(box, r.lo) + ' – ' + money(box, r.hi);
    var pr = moveThumbs && box.querySelector('price-range');
    if (pr && r.max > 0) {
      pr.style.setProperty('--progress-lower', (r.lo / r.max * 100) + '%');
      pr.style.setProperty('--progress-upper', (r.hi / r.max * 100) + '%');
    }
  }
  function apply(box) {
    clearTimeout(box._aoIdle);
    var f = fields(box), max = Number(box.getAttribute('data-max')) || 0;
    for (var i = 0; i < 2; i++) {
      if (f[i].value === '') continue;
      var v = Math.max(0, Math.min(Number(f[i].value) || 0, max));
      if (String(v) !== f[i].value) f[i].value = v;
    }
    if (f[0].value !== '' && f[1].value !== '' && Number(f[0].value) > Number(f[1].value)) {
      var t = f[0].value; f[0].value = f[1].value; f[1].value = t;
    }
    paint(box, true);
    var k = key(box);
    if (box._aoApplied === k) return;
    box._aoApplied = k;
    var ev = new Event('input', { bubbles: true });
    ev.aoApply = true;
    f[1].dispatchEvent(ev);   /* target inside the group: facets.js keeps the group, refreshes its label */
  }
  function initPrices() {
    root.querySelectorAll('[data-ao-price]').forEach(function (box) {
      if (box._aoApplied === undefined) { box._aoApplied = key(box); paint(box, false); }
    });
  }

  var dragBox = null, releasedBox = null;
  document.addEventListener('mousedown', function (e) {
    var th = e.target.closest && e.target.closest('.price-range__thumbs');
    dragBox = th && root.contains(th) ? th.closest('[data-ao-price]') : null;
  }, true);
  window.addEventListener('mouseup', function () {   /* capture: runs before the stock stopMove */
    releasedBox = dragBox; dragBox = null;
    setTimeout(function () { releasedBox = null; }, 0);
  }, true);

  document.addEventListener('input', function (e) {
    if (e.aoApply) return;
    var t = e.target;
    if (t.tagName === 'FORM' && root.contains(t)) {
      /* the stock slider's submit: keep it only straight after a real drag, and re-send it from inside the group */
      e.stopPropagation();
      if (releasedBox && t.contains(releasedBox)) apply(releasedBox);
      return;
    }
    var box = t.closest && t.closest('[data-ao-price]');
    if (!box || !root.contains(box) || t.type !== 'number') return;
    e.stopPropagation();
    paint(box, true);
    clearTimeout(box._aoIdle);
    box._aoIdle = setTimeout(function () { apply(box); }, IDLE_MS);
  }, true);
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-ao-price]');
    if (box && root.contains(box) && e.target.type === 'number') apply(box);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var box = e.target.closest && e.target.closest('[data-ao-price]');
    if (box && root.contains(box) && e.target.type === 'number') { e.preventDefault(); apply(box); }
  });

  /* After facets.js swaps markup: keep aria-expanded in step with the group state, and shorten the
     search page's count ("40 results found for “x”" → "40 results") inside the sheet button. */
  function sync() {
    root.querySelectorAll('.ao-f__mgroup').forEach(function (g) {
      var b = g.querySelector('[data-ao-acc]');
      if (b) b.setAttribute('aria-expanded', g.classList.contains('is-open') ? 'true' : 'false');
    });
    var c = document.getElementById('ProductCountMobile');
    if (c) {
      var m = c.textContent.match(/^\s*([\d,]+)\s+results?\b/);
      if (m) { var t = m[1] + ' results'; if (c.textContent !== t) c.textContent = t; }
    }
  }
  new MutationObserver(function (records) {
    var structural = false;
    records.forEach(function (r) {
      if (r.type === 'childList') { structural = true; return; }
      /* slider drag: the stock code moves the thumb by rewriting price-range's style; follow it in the readout */
      var box = r.target.closest && r.target.closest('[data-ao-price]');
      if (box) paint(box, false);
    });
    if (structural) { sync(); initPrices(); }
  }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  sync();
  initPrices();
})();
